var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E7F8E0",
    width: 20,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#48A446"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.952,
    y: 15
  }, "!")))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3QgZmlsbD0iI0U3RjhFMCIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMTAiLz4KICAgICAgICA8dGV4dCBmb250LWZhbWlseT0iUHJveGltYU5vdmEtQm9sZCwgUHJveGltYSBOb3ZhIiBmb250LXNpemU9IjE2IiBmb250LXdlaWdodD0iYm9sZCIgZmlsbD0iIzQ4QTQ0NiI+CiAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjcuOTUyIiB5PSIxNSI+ITwvdHNwYW4+CiAgICAgICAgICAgICAgICA8L3RleHQ+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgExclamationIcon as ReactComponent };